



import Overview from '../sections/overview/template_01';




import "./style.css";

const OverviewPage = ()=>{
return (
<div id="overviewPage" className="page">
  
  

  
  <Overview desktopTitleToggle={ false }
    mobileTitleToggle={ true } />
  
  
  
</div>
)
}

export default OverviewPage;